import { FILL_TYPES } from './bookingUtils';

export const FillTypeBadge = ({ type, compact = false }) => {
  const cfg = FILL_TYPES[type] || FILL_TYPES.CLIENT;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-semibold uppercase tracking-wide ${cfg.badge} ${compact ? 'px-1.5 py-px text-[10px]' : 'px-2.5 py-0.5 text-[11px]'}`}
      data-testid={`fill-type-badge-${(type || 'client').toLowerCase()}`}
    >
      <Icon className={compact ? 'w-2.5 h-2.5' : 'w-3 h-3'} />
      {cfg.label}
    </span>
  );
};

export const FillTypeLegend = () => (
  <div className="flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="fill-type-legend">
    {Object.entries(FILL_TYPES).map(([key, cfg]) => (
      <div key={key} className="flex items-center gap-2">
        <FillTypeBadge type={key} />
        <span className="text-xs text-slate-500">{cfg.description}</span>
      </div>
    ))}
  </div>
);
